import "./modules/firebaseInitialize";
import "./modules/pdfWorker";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Default from "./pages/default";
import Home from "./pages/home";
import Account from "./pages/account";
import Project from "./pages/project";
import DefaultLayout from "./layouts/default";
import View from "./pages/documents/view";
import Imprint from "./pages/imprint";
import Privacy from "./pages/privacy";
import "./index.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import DocumentsUsers from "./pages/documents/users";
import DocumentsStart from "./pages/documents/start";
import DocumentsList from "./pages/documents/list";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<React.StrictMode>
		<BrowserRouter>
			<Routes>
				<Route
					path="/"
					element={
						<DefaultLayout>
							<Home />
						</DefaultLayout>
					}
				/>
				<Route
					path="/imprint"
					element={
						<DefaultLayout>
							<Imprint />
						</DefaultLayout>
					}
				/>
				<Route
					path="/privacy"
					element={
						<DefaultLayout>
							<Privacy />
						</DefaultLayout>
					}
				/>
				<Route
					path="/account"
					element={
						<DefaultLayout>
							<Account />
						</DefaultLayout>
					}
				/>
				<Route
					path="/projects/:projectId"
					element={
						<DefaultLayout>
							<Project />
						</DefaultLayout>
					}
				/>
				<Route
					path="/projects/:projectId/documents"
					element={
						<DefaultLayout>
							<DocumentsStart />
						</DefaultLayout>
					}
				/>
				<Route
					path="/projects/:projectId/documents/users"
					element={
						<DefaultLayout>
							<DocumentsUsers />
						</DefaultLayout>
					}
				/>
				<Route
					path="/projects/:projectId/documents/project"
					element={
						<DefaultLayout>
							<DocumentsList />
						</DefaultLayout>
					}
				/>
				<Route
					path="/projects/:projectId/documents/users/:userId"
					element={
						<DefaultLayout>
							<DocumentsList />
						</DefaultLayout>
					}
				/>
				<Route
					path="/projects/:projectId/view/*"
					element={
						<DefaultLayout>
							<View />
						</DefaultLayout>
					}
				/>
				<Route
					path="*"
					element={
						<DefaultLayout>
							<Default />
						</DefaultLayout>
					}
				/>
			</Routes>
		</BrowserRouter>
	</React.StrictMode>,
);
